var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTelescope4 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.813 8.469a3.75 3.75 0 0 0-3.75-3.75m0 0a3.75 3.75 0 0 0-3.75 3.75m3.75-3.75V3.464a.57.57 0 0 1 .216-.443.7.7 0 0 1 .503-.145 5.9 5.9 0 0 1 5.36 4.93.56.56 0 0 1-.159.463.67.67 0 0 1-.481.2h-1.22m-.798-4.683 1.19-1.201 1.756 1.772-1.152 1.162M.968 15.031h12.188M2.531 8.47h9.063a.625.625 0 0 1 .625.625v5.937H1.906V9.094a.625.625 0 0 1 .625-.625m10.286-4.732-.548-.55a1.48 1.48 0 0 1 0-2.085l.02-.02a.37.37 0 0 1 .527 0l2.106 2.125a.38.38 0 0 1 0 .532 1.48 1.48 0 0 1-2.105-.002m-6.848 7.075h2.187a.313.313 0 0 1 .313.313v3.906H5.656v-3.906a.31.31 0 0 1 .313-.313"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.813 8.469a3.75 3.75 0 0 0-3.75-3.75m0 0a3.75 3.75 0 0 0-3.75 3.75m3.75-3.75V3.464a.57.57 0 0 1 .216-.443.7.7 0 0 1 .503-.145 5.9 5.9 0 0 1 5.36 4.93.56.56 0 0 1-.159.463.67.67 0 0 1-.481.2h-1.22m-.798-4.683 1.19-1.201 1.756 1.772-1.152 1.162M.968 15.031h12.188M2.531 8.47h9.063a.625.625 0 0 1 .625.625v5.937H1.906V9.094a.625.625 0 0 1 .625-.625m10.286-4.732-.548-.55a1.48 1.48 0 0 1 0-2.085l.02-.02a.37.37 0 0 1 .527 0l2.106 2.125a.38.38 0 0 1 0 .532 1.48 1.48 0 0 1-2.105-.002m-6.848 7.075h2.187a.313.313 0 0 1 .313.313v3.906H5.656v-3.906a.31.31 0 0 1 .313-.313"
  }));
});
export default SvgIconTelescope4;
export const raw = __webpack_public_path__ + "static/media/IconTelescope4.419845b15d8ff23d7562d50fe3b9b588.svg";